import { StyleSheet } from 'aphrodite';
import {
	brandPrimary,
	brandSecondaryHover,
	destructive as danger,
	success,
	darkGrayFontColor as grayText,
	borderOutline as borderGray,
	noteTintColor as warningYellow,
} from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	modalTitle: {
		color: brandSecondaryHover,
		marginBottom: '20px',
	},
	modalBody: {
		padding: '0 20px 20px',
		maxHeight: '60vh',
		overflowY: 'auto',
	},
	modalFooter: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '12px',
		marginTop: '24px',
		paddingTop: '20px',
		borderTop: `1px solid ${borderGray}`,
	},

	// Warning Section
	warningSection: {
		display: 'flex',
		gap: '12px',
		padding: '16px',
		backgroundColor: '#FFF9E6',
		border: `1px solid ${warningYellow}`,
		borderRadius: '4px',
		marginBottom: '20px',
	},
	warningIcon: {
		flexShrink: 0,
		width: '24px',
		height: '24px',
		fill: warningYellow,
	},
	warningText: {
		flex: 1,
		fontSize: '14px',
		lineHeight: '1.5',
		'& strong': {
			display: 'block',
			marginBottom: '8px',
			fontSize: '15px',
		},
		'& p': {
			margin: 0,
			color: grayText,
		},
	},

	// Instructions Section
	instructionsSection: {
		marginBottom: '20px',
	},
	instructionsTitle: {
		fontSize: '15px',
		fontWeight: 600,
		marginBottom: '12px',
	},
	instructionsList: {
		margin: 0,
		paddingLeft: '20px',
		fontSize: '14px',
		lineHeight: '1.8',
		color: grayText,
	},

	// Input Section
	inputSection: {
		marginBottom: '20px',
	},
	inputLabel: {
		display: 'block',
		fontSize: '14px',
		fontWeight: 500,
		marginBottom: '8px',
	},
	textarea: {
		width: '100%',
		minHeight: '200px',
		padding: '12px',
		fontSize: '13px',
		fontFamily: 'monospace',
		border: `1px solid ${borderGray}`,
		borderRadius: '4px',
		resize: 'vertical',
		marginTop: '8px',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	textareaError: {
		borderColor: danger,
	},
	errorMessage: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		marginTop: '8px',
		padding: '8px 12px',
		backgroundColor: '#FFF5F5',
		border: `1px solid ${danger}`,
		borderRadius: '4px',
		fontSize: '13px',
		color: danger,
	},
	errorIcon: {
		flexShrink: 0,
		width: '16px',
		height: '16px',
		fill: danger,
	},

	// Keywords Section
	keywordsSection: {
		marginBottom: '20px',
	},
	keywordsInput: {
		width: '100%',
		padding: '10px 12px',
		fontSize: '14px',
		border: `1px solid ${borderGray}`,
		borderRadius: '4px',
		marginTop: '8px',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	keywordsHelp: {
		marginTop: '8px',
		fontSize: '12px',
		color: grayText,
		fontStyle: 'italic',
	},

	// Loading State
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '60px 20px',
	},
	loadingText: {
		marginTop: '20px',
		fontSize: '14px',
		color: grayText,
	},

	// Results Section
	resultsContainer: {
		minHeight: '300px',
	},
	summarySection: {
		marginBottom: '24px',
	},
	summaryTitle: {
		fontSize: '16px',
		fontWeight: 600,
		marginBottom: '16px',
	},
	summaryStats: {
		display: 'flex',
		gap: '20px',
		flexWrap: 'wrap',
	},
	statItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		fontSize: '14px',
	},
	statIcon: {
		width: '20px',
		height: '20px',
	},
	statSuccess: {
		color: success,
	},
	statError: {
		color: danger,
	},
	successIcon: {
		color: success,
		fontSize: '20px',
		marginRight: '8px',
	},
	successCheckmark: {
		color: success,
		fontSize: '18px',
	},

	// Results Details
	detailsSection: {
		marginTop: '20px',
	},
	detailsTitle: {
		fontSize: '14px',
		fontWeight: 600,
		marginBottom: '12px',
	},
	resultsTable: {
		maxHeight: '300px',
		overflowY: 'auto',
		border: `1px solid ${borderGray}`,
		borderRadius: '4px',
	},
	resultRow: {
		display: 'flex',
		gap: '12px',
		padding: '12px',
		borderBottom: `1px solid ${borderGray}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	resultSuccess: {
		backgroundColor: '#F0FFF4',
	},
	resultError: {
		backgroundColor: '#FFF5F5',
	},
	resultIcon: {
		flexShrink: 0,
		width: '20px',
		height: '20px',
	},
	resultIconSuccess: {
		fill: success,
	},
	resultIconError: {
		fill: danger,
	},
	resultDetails: {
		flex: 1,
		fontSize: '13px',
	},
	resultName: {
		fontWeight: 500,
		marginBottom: '4px',
	},
	resultReference: {
		color: grayText,
		fontSize: '12px',
		fontFamily: 'monospace',
	},
	resultErrorMessage: {
		color: danger,
		fontSize: '12px',
		marginTop: '4px',
	},
});
